const routes = {
  CareNavigatorsBrowseDetail: {
    to: '/apps/Browse/care_navigators/[uid]',
    as: '/browse/care_navigators/:uid',
    pathname: '/browse/care_navigators/[uid]',
  },
  TherapistsBrowseDetail: {
    to: '/apps/Browse/therapists/[uid]',
    as: '/browse/therapists/:uid',
    pathname: '/browse/therapists/[uid]',
  },
  PhysiciansBrowseDetail: {
    to: '/apps/Browse/physicians/[uid]',
    as: '/browse/physicians/:uid',
    pathname: '/browse/physicians/[uid]',
  },
  CoachesBrowseDetail: {
    to: '/apps/Browse/coaches/[uid]',
    as: '/browse/coaches/:uid',
    pathname: '/browse/coaches/[uid]',
  },
  SpecialtyCareNavigatorsBrowseDetail: {
    to: '/apps/Browse/specialty_care_navigators/[uid]',
    as: '/browse/specialty_care_navigators/:uid',
    pathname: '/browse/specialty_care_navigators/[uid]',
  },
  PeerRecoverySpecialistsBrowseDetail: {
    to: '/apps/Browse/peer_recovery_specialists/[uid]',
    as: '/browse/peer_recovery_specialists/:uid',
    pathname: '/browse/peer_recovery_specialists/[uid]',
  },
  SkillsMentorsBrowseDetail: {
    to: '/apps/Browse/skills_mentors/[uid]',
    as: '/browse/skills_mentors/:uid',
    pathname: '/browse/skills_mentors/[uid]',
  },
  care_navigator: {
    pathname: '/browse/care_navigators/[uid]',
  },
  therapist: {
    pathname: '/browse/therapists/[uid]',
  },
  medication_manager: {
    pathname: '/browse/physicians/[uid]',
  },
  coach: {
    pathname: '/browse/coaches/[uid]',
  },
  specialty_care_navigator: {
    pathname: '/browse/specialty_care_navigators/[uid]',
  },
  peer_recovery_specialist: {
    pathname: '/browse/peer_recovery_specialists/[uid]',
  },
  skills_mentor: {
    pathname: '/browse/skills_mentors/[uid]',
  },
};

export default routes;
